import PageLoadedQueue from "../Project/PageLoadedQueue";

function createIndicator(element: HTMLElement) {
    // Create the indicator
    const indicator = document.createElement('div');
    indicator.classList.add('max-length-indicator', 'text-end');

    element.after(indicator);

    return indicator;
}

function createBadge(indicator: HTMLElement, maxLength: number, textLength: number) {
    const badge = document.createElement('span');
    badge.classList.add('badge', 'text-bg-success');
    badge.textContent = textLength + '/' + maxLength;

    indicator.appendChild(badge);

    return badge;
}

function keyUpEventFunction(element: HTMLElement, badge: HTMLElement, maxLength: number, textLength: number) {
    element.classList.remove('max-length-indicator-enabled');

    badge.textContent = textLength + '/' + maxLength;
    badge.classList.remove('text-bg-danger');
    badge.classList.add('text-bg-success');

    if (textLength >= maxLength * 0.95) {
        badge.classList.remove('text-bg-success');
        badge.classList.add('text-bg-warning');
    }
    if (textLength >= maxLength) {
        badge.classList.remove('text-bg-warning');
        badge.classList.add('text-bg-danger');
    }

    if (textLength > maxLength) {
        if (element instanceof HTMLInputElement) {
            element.value = element.value.slice(0, maxLength);
            element.selectionStart = element.value.length;
        } else {
            element.textContent = element.textContent.slice(0, maxLength);
            element.selectionStart = element.textContent.length;
        }
    }

    if (textLength === maxLength) {
        element.classList.add('max-length-indicator-enabled');
    }
}

function initEvents(element: HTMLElement, indicator: HTMLElement) {
    // Remove the indicator animation class after the animation ends to re-enable it
    element.addEventListener("animationend", () => {
        element.classList.remove('max-length-indicator-enabled');
    }, {passive: true});

    // Show the indicator on focus
    element.addEventListener('focus', () => {
        indicator.style.display = 'block';
    });

    // Hide the indicator on blur
    element.addEventListener('blur', () => {
        indicator.style.display = 'none';
    });
}

export function InputMaxLengthIndicatorDiv(input: HTMLDivElement) {
    const maxLength = parseInt(input.getAttribute('maxlength') || input.dataset.maxlength || '0');
    if (!maxLength) return;

    const indicator = createIndicator(input);
    const badge = createBadge(
        indicator,
        maxLength,
        input.textContent.length
    );

    input.addEventListener('keyup', function() {
        keyUpEventFunction(
            input,
            badge,
            maxLength,
            this.textContent.length
        );
    }, {passive: true});
    initEvents(input, indicator);
}

export function InputMaxLengthIndicator(input: HTMLInputElement|HTMLTextAreaElement) {
    const maxLength = parseInt(input.getAttribute('maxlength') || input.dataset.maxlength || '0');
    if (!maxLength) return;

    const indicator = createIndicator(input);
    const badge = createBadge(
        indicator,
        maxLength,
        input.value.length
    );

    input.addEventListener('keyup', function() {
        keyUpEventFunction(
            input,
            badge,
            maxLength,
            this.value.length
        );
    }, {passive: true});
    initEvents(input, indicator);
}

export function initInputMaxLengthIndicator() {
    const inputs = document.querySelectorAll('input[data-maxlength-indicator="1"],input[data-maxlength-indicator="true"]');
    inputs.forEach(input => InputMaxLengthIndicator(input as HTMLInputElement));

    const textareas = document.querySelectorAll('textarea[data-maxlength-indicator="1"],textarea[data-maxlength-indicator="true"]');
    textareas.forEach(textarea => InputMaxLengthIndicator(textarea as HTMLTextAreaElement));

    const divElements = document.querySelectorAll('div[data-maxlength][data-maxlength-indicator="1"],div[data-maxlength][data-maxlength-indicator="true"]');
    divElements.forEach(divElement => InputMaxLengthIndicatorDiv(divElement as HTMLDivElement));
}

PageLoadedQueue.addFunction(initInputMaxLengthIndicator);
